import React from "react";
import {Outlet, useRouteLoaderData} from "react-router";
import {AuthStateProvider} from "@/context/authentication/auth-state-provider";
import {LoadedData} from "./user-loader";

const AuthStateLayout = () => {
    const {user} = useRouteLoaderData("auth-root") as LoadedData;

    return (
        <AuthStateProvider initialUser={user}>
            <Outlet/>
        </AuthStateProvider>
    );
};

export default AuthStateLayout;